<template>
  <div id="appNav">
    <nav class="navbar navbar-expand-lg bgColor">
      <a class="navbar-brand" href="#home">
        <img src="../assets/tribeidblack-min (1).png" height="30" alt loading="lazy" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fa fa-bars"></i>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="padding d-flex justify-content-center">
          <ul class="navbar-nav d-flex justify-content-between">
            <li class="nav-item active">
              <a class="nav-link" href="#about">
                About
                <span class="sr-only">(current)</span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#whysignup">Why sign up</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#tribeId">
                <img src="../assets/tribeidblack-min (1).png" height="30" alt loading="lazy" />
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#">Apply</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import $ from "jquery";
$(window).scroll(function() {
	$("nav").toggleClass("scrolled", $(this).scrollTop() > 0);
});
export default {};
</script>

<style scoped>
.bgColor.scrolled {
	background-color: #fff;
}
nav {
	width: 100%;
	top: 0;
	z-index: 10;
	position: fixed;
	text-align: center;
	height: 60px;
  background-color:#fff;
}
.navbar-nav li {
	padding: 0 10px;
}
.navbar-nav li a {
	font-weight: 600;
	float: right;
	text-align: left;
	color: #ba2428;
}

.fa-bars {
	color: #ba2428;
	font-size: 30px !important;
}
.navbar-toggler {
	outline: none;
}
.navbar-brand {
	display: none;
}
.padding {
	text-align: center;
	width: 100%;
}
ul {
	width: 80%;
}
/* media queries */

@media screen and (max-width: 991px) {
	.navbar-collapse {
		background-color: #fff;
		width: 100%;
		padding: 30px;
		color: red !important;
	}
	.navbar-brand {
		display: inline;
	}
}
</style>
